import { Download } from "lucide-react";

import { Button } from "@/components/ui/button";

interface TemplateDownloadBannerProps {
  title: string;
  description?: string;
  href?: string;
  buttonLabel?: string;
}

export function TemplateDownloadBanner({
  title,
  description,
  href,
  buttonLabel = "Abrir plantilla",
}: TemplateDownloadBannerProps) {
  if (!href) return null;

  return (
    <div className="rounded-md border bg-muted/30 px-3 py-2">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-medium truncate">{title}</p>
          {description && (
            <p className="text-xs text-muted-foreground truncate">
              {description}
            </p>
          )}
        </div>
        <Button variant="outline" size="sm" asChild>
          <a href={href} target="_blank" rel="noopener noreferrer">
            <Download className="mr-2 h-3.5 w-3.5" /> {buttonLabel}
          </a>
        </Button>
      </div>
    </div>
  );
}
